import React from 'react';
import Alert from 'react-bootstrap/Alert';

const BeheerAudio = () => {
    return (
        <>
            <h1>Audio</h1>
            <Alert variant="danger">
                Toegang tot deze pagina krijg je enkel nadat je bent aangemeld en je beschikt over de nodige accreditaties om de audio te bedienen.
            </Alert>
        </>
    );
}

export default BeheerAudio;
